module.exports = __webpack_public_path__ + "img/01.16a11562.jpg";